import { useState } from "react";

const useSso = (resolvedClientId, cognitoDomain, setErrorMessage) => {
  const [showSSOModal, setShowSSOModal] = useState(false);
  const [ssoProviders, setSSOProviders] = useState([]);
  const [loadingSSOProviders, setLoadingSSOProviders] = useState(false);

  const handleSSOLogin = async () => {
    setShowSSOModal(true);
    setLoadingSSOProviders(true);

    try {
      // For now, hardcode the provider. In the future, this could fetch from an API
      const providers = [
        {
          id: "medvol",
          name: "Medvol",
          displayName: "Medvol SSO",
          type: "SAML",
        },
        {
          id: "mrikal",
          name: "Mrikal",
          displayName: "Mrikal SSO",
          type: "SAML",
        },
        {
          id: "coloplast",
          name: "Coloplast",
          displayName: "Coloplast SSO",
          type: "SAML",
        },
      ];

      setSSOProviders(providers);
    } catch (error) {
      console.error("Error loading SSO providers:", error);
      if (setErrorMessage) {
        setErrorMessage("Failed to load SSO providers");
      }
    } finally {
      setLoadingSSOProviders(false);
    }
  };

  const handleProviderSelect = (provider) => {
    if (!cognitoDomain) {
      console.error("Cognito domain is not configured");
      if (setErrorMessage) {
        setErrorMessage("SSO is unavailable right now. Please try again later.");
      }
      return;
    }

    const params = new URLSearchParams({
      identity_provider: provider.name,
      redirect_uri: `${window.location.origin}/sso/callback`,
      response_type: "code",
      client_id: resolvedClientId,
      scope: "openid profile phone",
    });

    const ssoUrl = `${cognitoDomain}/oauth2/authorize?${params.toString()}`;

    console.log("Redirecting to SSO:", ssoUrl);
    window.location.href = ssoUrl;
  };

  return {
    showSSOModal,
    setShowSSOModal,
    ssoProviders,
    loadingSSOProviders,
    handleSSOLogin,
    handleProviderSelect,
  };
};

export default useSso;


